var map = {
	"./culture/chinese-new-year-traditions/index.md": [
		8538,
		157
	],
	"./culture/chinese-tea-culture/index.md": [
		3142,
		761
	],
	"./culture/dragon-dance-traditions/index.md": [
		4135,
		135
	],
	"./culture/lantern-festival-2025/index.md": [
		9851,
		851
	],
	"./culture/mid-autumn-festival-2025/index.md": [
		272,
		272
	],
	"./culture/year-of-snake-2025/index.md": [
		2242,
		242
	],
	"./explore/daocheng-yading/index.md": [
		8713,
		713
	],
	"./explore/jiuzhaigou-valley/index.md": [
		5988,
		988
	],
	"./explore/kanas-lake-xinjiang/index.md": [
		6316,
		316
	],
	"./explore/pingtan-island/index.md": [
		1098,
		98
	],
	"./explore/shangli-ancient-town/index.md": [
		4331,
		331
	],
	"./explore/wuyuan-countryside/index.md": [
		724,
		724
	],
	"./explore/yangshuo-li-river/index.md": [
		6538,
		538
	],
	"./stories/great-wall-family-history/index.md": [
		2631,
		631
	],
	"./stories/life-changing-china-experience/index.md": [
		7520,
		520
	],
	"./stories/modern-china-traditional-culture/index.md": [
		913,
		913
	],
	"./stories/tea-culture-bridge/index.md": [
		8486,
		486
	],
	"./stories/teaching-english-rural-china/index.md": [
		4574,
		193
	],
	"./stories/vr-poetry-experience/index.md": [
		3574,
		574
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6211;
module.exports = webpackAsyncContext;